import React from 'react';
import { m } from 'motion/react';
import { useSeoHead } from '../hooks/useSeoHead';
import { getRoutePair, hreflangFor, SITE_URL } from '../seoRoutes';

const PAIR = getRoutePair('imprint');

const Impressum = () => {
  useSeoHead({
    title: PAIR.de.title,
    description: PAIR.de.description,
    canonical: `${SITE_URL}${PAIR.de.path}`,
    indexable: PAIR.indexable,
    htmlLang: 'de',
    hreflang: hreflangFor(PAIR),
  });

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <m.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-5xl font-display font-bold mb-8 text-pstax-navy">Impressum</h1>
          
          <div className="grid md:grid-cols-2 gap-12 text-pstax-gray leading-relaxed">
            <div className="space-y-8">
              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Medieninhaber und Herausgeber</h2>
                <p className="text-lg font-bold text-pstax-navy">PSTax Steuerberatung FlexCo</p>
              </section>

              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Anschrift</h2>
                <p>Biberhaufenweg 78/19</p>
                <p>1220 Wien, Österreich</p>
              </section>

              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Kontakt</h2>
                <p>E-Mail: <a href="mailto:office@pstax.at" className="text-pstax-navy font-bold hover:text-pstax-blue transition-colors">office@pstax.at</a></p>
                <p>Web: <a href="https://pstax.at" className="text-pstax-navy font-bold hover:text-pstax-blue transition-colors">pstax.at</a></p>
              </section>
            </div>

            <div className="space-y-8">
              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Angaben gemäß gesetzlichen Anforderungen</h2>
                <p className="mb-2"><strong>Sitz der Gesellschaft:</strong> Wien</p>
                <p className="mb-2"><strong>Unternehmensgegenstand:</strong> Steuerberatung</p>
                <p className="mb-2"><strong>Rechtsform:</strong> Flexible Kapitalgesellschaft (FlexCo)</p>
                <p className="mb-2"><strong>Firmenbuchnummer:</strong> FN 634911 v</p>
                <p className="mb-2"><strong>Firmenbuchgericht:</strong> Handelsgericht Wien</p>
                <p className="mb-2"><strong>UID-Nummer:</strong> ATU81086478</p>
                <p className="mb-2"><strong>Geschäftsführer:</strong> Pascal Schraml</p>
              </section>

              <section>
                <h2 className="text-[10px] font-black uppercase tracking-[0.2em] text-pstax-blue mb-2">Berufsrechtliche Zugehörigkeit</h2>
                <p className="mb-2"><strong>Berufsbezeichnung:</strong> Steuerberater, verliehen in Österreich</p>
                <p>Kammer der Steuerberater und Wirtschaftsprüfer (KSW)</p>
                <p>Am Belvedere 10 / Top 4, 1100 Wien</p>
                <p className="mt-2 text-xs">WT-Code: 241511</p>
              </section>
            </div>
          </div>

          <div className="mt-16 p-8 bg-pstax-bg rounded-3xl border border-pstax-border">
            <h2 className="text-xl font-display font-bold text-pstax-navy mb-4">Haftungsausschluss</h2>
            <p className="text-sm text-pstax-gray leading-relaxed italic">
              Die auf dieser Website bereitgestellten Informationen dienen lediglich allgemeinen Informationszwecken und stellen keine professionelle Steuer- oder Rechtsberatung dar. Obwohl wir uns bemühen, die Informationen aktuell und korrekt zu halten, geben wir keine Zusicherungen oder Gewährleistungen jeglicher Art über die Vollständigkeit, Genauigkeits oder Eignung des Website-Inhalts. Jegliches Vertrauen, das Sie auf solche Informationen setzen, geschieht daher ausschließlich auf Ihr eigenes Risiko.
            </p>
          </div>
        </m.div>
      </div>
    </div>
  );
};

export default Impressum;
